import { formatDate } from "../services/receipt.service";
import {
    buildDocDefinition, openPdf, headerRow, dataRow, totalRow, emptyRow,
    fmtLongDate, sumBy,
} from "./reportTheme";

export const DailyPoojaReportPrint = async (selectedDate, logoBase64, dailyPoojaReportList = []) => {
    const totalPersons = sumBy(dailyPoojaReportList, "totalPerson");

    const body = [
        headerRow("Persons"),
        ...dailyPoojaReportList.map((item, i) => dataRow(item, i, item.totalPerson || "-", formatDate)),
    ];
    body.push(
        dailyPoojaReportList.length
            ? totalRow("Total No of Persons", String(totalPersons), { grand: true })
            : emptyRow()
    );

    return openPdf(
        buildDocDefinition({
            logoBase64,
            title: "Booked Seva List",
            summary: [
                { label: "Date", value: fmtLongDate(selectedDate) },
                { label: "Total Bookings", value: dailyPoojaReportList.length },
                { label: "Total Persons", value: totalPersons, accent: true },
            ],
            body,
        })
    );
};

export default DailyPoojaReportPrint;